module.exports = __webpack_public_path__ + "media/images/contactese/telefono-0af94adb86d96c369d80758c87d62fe2.svg";